import { GlobalsService } from "./../../api/globals.service";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { multi } from "./data";
import { graph } from "./date";
import { TranslateService } from "@ngx-translate/core";
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexTitleSubtitle,
  ApexStroke,
  ApexGrid,
  ApexYAxis,
  ApexFill,
  ApexMarkers,
  ApexPlotOptions,
  ApexResponsive,
  ApexLegend,
} from "ng-apexcharts";
import { CursosService } from "src/app/services/cursos.service";
import { AuthService } from "src/app/services/auth.service";
import { ActivatedRoute } from "@angular/router";

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  dataLabels: ApexDataLabels;
  yaxis: ApexYAxis;
  grid: ApexGrid;
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
  fill: ApexFill;
};

export type ChartOptRadar = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  title: ApexTitleSubtitle;
  stroke: ApexStroke;
  fill: ApexFill;
  markers: ApexMarkers;
  xaxis: ApexXAxis;
  plotOptions: ApexPlotOptions;
};

export type ChartOpBar = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  grid: ApexGrid;
  title: ApexTitleSubtitle;
  responsive: ApexResponsive[];
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  legend: ApexLegend;
  fill: ApexFill;
  colors?: string[];
};
@Component({
  selector: "app-estadisticas",
  templateUrl: "./estadisticas.component.html",
  styleUrls: ["./estadisticas.component.scss"],
})
export class EstadisticasComponent implements OnInit {
  @ViewChild("chart") chart: ChartComponent;
  @ViewChild("chartRadar") chartRadar: ChartComponent;
  public chartOptions: Partial<ChartOptions>;
  public chartOptRadar: Partial<ChartOptRadar>;
  public chartOpBar: Partial<ChartOpBar>;
  @Input() curso: any;
  @Input() perfil: any;
  @Input() data_estudiantes: any[];

  data_estudiante: any;
  data_teacher: any;
  ID: number;
  AUTH_KEY: string;
  displayUserData: any;
  id_cours = null;
  isMobile = false;
  student: any;
  showChart: boolean = true;
  showResults: boolean = false;
  public results: any[] = [];
  constructor(
    private globalsService: GlobalsService,
    private translate: TranslateService,
    private cursosService: CursosService,
    private authService: AuthService,
    private activeRoute: ActivatedRoute
  ) {
    this.getCalif();
    this.id_cours = this.activeRoute.snapshot.paramMap.get("id_curso");
  }

  ngOnInit() {
    this.isMobile = this.globalsService.isMobile;
    setTimeout(() => (window as any).dispatchEvent(new Event("resize")), 1);
    this.getDataUser(this.ID);
    this.results = this.data_estudiantes;
  }

  getDataUser(idStudent) {
    if (this.perfil === "student" || this.student) {
      this.getStudetTable(idStudent);
      this.cursosService
        .getAct(this.AUTH_KEY, this.id_cours, this.ID, idStudent)
        .subscribe((res: any) => {
          this.loadGraphBar(res.graficaBarras);
          this.loadGrphiLine(res.estadistica, res.promedioEst);
          this.perfil === "student"
            ? this.loadGrapRadar(res.habilidadesCursoEst)
            : this.loadGrapRadar(res.habilidadesCurso, res.habilidadesCursoEst);
        });
    } else {
      this.getTeacherable();
      this.cursosService
        .getActDate(this.AUTH_KEY, this.id_cours, this.ID, idStudent)
        .subscribe((res: any) => {
          this.chartOptions = undefined;
          this.chartOptRadar = undefined;
          this.loadGrapRadar(res.habilidadesCurso);
          this.loadGraphBar(res.promedioPorActividades);
        });
    }
  }

  loadGrphiLine(estadistica: any[], promedio = 0) {
    var distribucion = estadistica
      .sort((a, b) => a.calificacion - b.calificacion)
      .map((item) => {
        return {
          x: item.calificacion,
          y: item.estudiantes,
        };
      });
    var persentil = distribucion
      .filter((item) => item.x >= promedio)
      .sort((a, b) => b.x - a.x);
    this.chartOptions = {
      series: [
        {
          name: "Distribución",
          data: distribucion, // Datos de la curva de distribución
          type: "line",
        },
        {
          name: "Percentil",
          data: persentil, // Datos para sombrear el percentil
          type: "area",
        },
      ],
      chart: {
        type: "line",
        height: 350,
        toolbar: {
          show: false,
        },
      },
      stroke: {
        curve: "smooth",
        width: 3,
        colors: ["#8ed2f0"],
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "horizontal",
          shadeIntensity: 0.5,
          gradientToColors: ["#8ed2f0"],
          opacityFrom: 0.6,
          opacityTo: 0,
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        title: {
          text: "Promedio",
          style: {
            color: "#a4c466",
            fontWeight: 600,
          },
        },
        labels: {
          formatter: (value) => Number(value).toFixed(1),
        },
      },
      yaxis: {
        title: {
          text: "Cantidad estudiantes",
          style: {
            color: "#a4c466",
            fontWeight: 600,
          },
        },
        labels: {
          formatter: (value) => Math.round(value).toString(),
        },
        max: 20,
      },
      title: {
        text: "Promedio por actividad",
        align: "center",
        style: {
          fontSize: "16px",
          color: "#333",
        },
      },
    };
  }

  loadGrapRadar(radarData, studentData = null) {
    // Ocultar el gráfico temporalmente
    this.showChart = false;
    // Inicializa this.chartOptRadar al principio de la función
    this.chartOptRadar = {
      series: [],
      chart: {
        width: "100%",
        height: 500,
        type: "radar",
        dropShadow: {
          enabled: true,
          blur: 1,
          left: 1,
          top: 1,
        },
      },
      markers: {
        size: 4,
      },
      title: {
        text: "Gráfico por habilidades",
        align: "center",
      },
      stroke: {
        width: 2,
      },
      fill: {
        opacity: 0.4,
      },
      xaxis: {
        categories: [],
        axisBorder: {
          show: true,
          color: "#000000",
        },
        axisTicks: {
          show: true,
          color: "#000000",
        },
      },
      plotOptions: {
        radar: {
          polygons: {
            fill: {
              colors: ["#000000", "#000000"],
            },
          },
        },
      },
    };

    var data = radarData.map((item) => {
      return {
        x: item.habilidad,
        y: item.promedio,
      };
    });
    var categories = data.map((item) => item.x);
    var seriesData = data.map((item) => parseFloat(item.y.toFixed(1)));

    this.chartOptRadar.xaxis.categories = categories;

    if (studentData) {
      var seriesData2 = studentData.map((item) =>
        parseFloat(item.promedio.toFixed(1))
      );
      this.chartOptRadar.series.push(
        {
          name: "Curso",
          data: seriesData,
        },
        {
          name: this.student.nombre,
          data: seriesData2,
        }
      );
    } else {
      this.chartOptRadar.series.push({
        name: "Curso",
        data: seriesData,
      });
    }
    if (window.innerWidth <= 768) {
      this.chartOptRadar.chart.height = 300;
      this.chartOptRadar.plotOptions = {
        radar: {
          size: 80, // más pequeño en móvil
        },
      };
    }
    // Mostrar el gráfico nuevamente después de un breve retraso
    setTimeout(() => {
      this.showChart = true;
    }, 0);
  }

  getCalif() {
    this.authService.userData$.subscribe((res: any) => {
      if (res) {
        if (!this.displayUserData) {
          this.displayUserData = res;
          this.ID = this.displayUserData?.id;
          this.AUTH_KEY = this.displayUserData?.auth_key;
        }
      }
    });
  }

  getPromStudent(idStudent = this.ID) {
    this.cursosService
      .getAct(this.AUTH_KEY, this.id_cours, this.ID, idStudent)
      .subscribe(
        (getactss: any) => {
          if (getactss) {
            let esdist = getactss;
          } else {
            console.log("No se recibieron datos de actividades.");
          }
        },
        (error) => {
          console.error("Error al obtener datos de actividades:", error);
        }
      );
  }

  getTeacherable() {
    this.cursosService
      .getCalifTeache(this.AUTH_KEY, this.id_cours, this.ID)
      .subscribe(
        (calfTeach: any) => {
          this.data_teacher = calfTeach;
        },
        (error) => {
          console.error("Error al obtener datos de calificaciones:", error);
        }
      );
  }

  getStudetTable(idStudent) {
    this.cursosService
      .getCalifica(this.AUTH_KEY, this.id_cours, this.ID, idStudent)
      .subscribe(
        (calf: any) => {
          this.data_estudiante = calf;
        },
        (error) => {
          console.error("Error al obtener datos de calificaciones:", error);
        }
      );
  }

  loadGraphBar(dataBar) {
    console.log(
      "🚀 ~ EstadisticasComponent ~ loadGraphBar ~ dataBar:",
      dataBar
    );
    if (this.isMobile) {
      this.chartOpBar = {
        series: [
          {
            name: "Actividades",
            data: dataBar.map((item) => item.promedio),
          },
        ],
        chart: {
          type: "bar",
          height: dataBar.length < 5 ? 500 : dataBar.length * 45,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "50%",
            distributed: true, // 👈 permite colores diferentes por barra
          },
        },
        colors: this.generarColores(dataBar.length), // 👈 generador de colores personalizado
        xaxis: {
          categories: dataBar.map((item) => item.actividad), // 👈 esto es correcto aquí
          title: {
            text: "Calificación",
          },
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
        yaxis: {
          title: {
            text: "Actividades",
          },
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
        legend: {
          show: false, // 👈 se suele ocultar en gráficos distribuidos (1 color por barra)
        },
        title: {
          text: "Promedio por Actividad",
          align: "center",
        },
        responsive: [
          {
            breakpoint: 768,
            options: {
              chart: {
                height: dataBar.length < 5 ? 500 : dataBar.length * 45,
              },
              xaxis: {
                labels: {
                  style: {
                    fontSize: "10px",
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontSize: "10px",
                  },
                },
              },
            },
          },
        ],
      };
    } else {
      this.chartOpBar = {
        series: [
          {
            name: "Actividades",
            data: dataBar.map((item) => item.promedio),
          },
        ],
        chart: {
          height: dataBar.length < 5 ? 500 : dataBar.length * 45,
          type: "bar",
        },
        title: {
          text: "Promedio por Actividad",
          align: "center",
        },
        xaxis: {
          categories: dataBar.map((item) => item.actividad),
          title: {
            text: "Actividades",
          },
          labels: {
            rotate: -45,
            style: {
              fontSize: "12px",
            },
          },
        },
        yaxis: {
          title: {
            text: "Calificación",
          },
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
        colors: this.generarColores(dataBar.length),
        plotOptions: {
          bar: {
            distributed: true,
          },
        },
        legend: {
          position: "right",
          horizontalAlign: "center",
          fontSize: "13px",
        },
        responsive: [
          {
            breakpoint: 768, // tablets y móviles
            options: {
              chart: {
                height: dataBar.length < 5 ? 500 : dataBar.length * 45,
              },
              legend: {
                position: "bottom",
                fontSize: "11px",
              },
              xaxis: {
                labels: {
                  rotate: -60,
                  style: {
                    fontSize: "10px",
                  },
                },
                title: {
                  style: {
                    fontSize: "11px",
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontSize: "10px",
                  },
                },
                title: {
                  style: {
                    fontSize: "11px",
                  },
                },
              },
            },
          },
          {
            breakpoint: 480, // móviles pequeños
            options: {
              chart: {
                height: 250,
              },
              legend: {
                position: "bottom",
                fontSize: "10px",
              },
              xaxis: {
                labels: {
                  rotate: -65,
                  style: {
                    fontSize: "9px",
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontSize: "9px",
                  },
                },
              },
            },
          },
        ],
      };
    }
  }

  onChangeStudent(data) {
    this.student = data;
    this.getDataUser(data ? data.id_user : null);
  }

  generarColores(cantidad) {
    const colores = [];
    for (let i = 0; i < cantidad; i++) {
      const hue = (i * 360) / cantidad; // Calcula un tono diferente para cada color
      const color = `hsl(${hue}, 70%, 50%)`; // Saturación y luminosidad constantes
      colores.push(color);
    }
    return colores;
  }

  handleInput(event) {
    const query = event.target.value.toLowerCase();
    this.results = this.data_estudiantes.filter(
      (d) => d.nombre.toLowerCase().indexOf(query) > -1
    );
  }

  hideResultsWithDelay() {
    setTimeout(() => {
      this.showResults = false;
    }, 200); // Retraso de 200 ms
  }
}
